/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'yurstrap';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]).isRequired,
    color: PropTypes.oneOf(['primary', 'secondary']),
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

const defaultProps = {
    ...commonDefaultProps,
    color: 'primary',
    componentClass: 'button',
    disabled: false,
    type: 'button',
};

const AddButton = (props) => {
    const classNames = [
        'c-add-btn',
        `c-add-btn--${props.color}`,
        props.disabled ? 'c-add-btn_is-disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            type={props.componentClass === 'button' ? props.type : null}
            className={concatClassNames(classNames)}
            disabled={props.disabled}
            {...filterProps(propTypes, props)}
        >
            <span className="c-add-btn__icon">
                <Icon icon="plus" />
            </span>
            <span className="c-add-btn__text">
                {props.children}
            </span>
        </props.componentClass>
    );
};

AddButton.propTypes = propTypes;

AddButton.defaultProps = defaultProps;

export default AddButton;
